import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import ResultsCarousel from "../components/ResultsCarousel";
import StrongNumbers from "../components/StrongNumbers";
import PaleCombinator from "../components/PaleCombinator";
import FeaturedNumbers from "../components/FeaturedNumbers";
import ZodiacNumbers from "../components/ZodiacNumbers";
import VipNumber from "../components/VipNumber";
import InterestLinks from "../components/InterestLinks";
import InfoSections from "../components/InfoSections";
import LotteriesSection from "../components/LotteriesSection";
import PerLotteryPales from "../components/PerLotteryPales";
import Footer from "../components/Footer";
import CookieBanner from "../components/CookieBanner";

export default function Home() {
  return (
    <div className="min-h-screen text-left">
      <Header />
      <ResultsCarousel />
      <Hero />
      <StrongNumbers />
      <LotteriesSection />
      <PaleCombinator />
      <FeaturedNumbers />
      <ZodiacNumbers />
      <VipNumber />
      <PerLotteryPales />
      <InterestLinks />
      <InfoSections />
      <Footer />
      <CookieBanner />
    </div>
  );
}
